import { render, staticRenderFns } from "./associationDetail.vue?vue&type=template&id=62a70aa7&scoped=true&"
import script from "./associationDetail.vue?vue&type=script&lang=js&"
export * from "./associationDetail.vue?vue&type=script&lang=js&"
import style0 from "./associationDetail.vue?vue&type=style&index=0&id=62a70aa7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a70aa7",
  null
  
)

export default component.exports